import React from 'react'
import View from './view'

const AboutUs = ({ ...props }) => {
  return <View {...props} />
}

export default AboutUs
